import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import EditChoice from './EditChoice';
import SingleChoice from './SingleChoice';

function QuestionChoices({quizId, questionId, correctAmount, setCorrectAmount, isSubmitted, mode, answeredAmount, setAnsweredAmount}) {

    const [choices, setChoices] = useState([]);
    const [selected, setSelected] = useState("");

    const [currentAnswerAmount, setCurrentAnswerAmount] = useState(0)

    useEffect(() => {

        try {
            const choicesRef = firestore.collection("quiz").doc(quizId).collection("questions").doc(questionId).collection("choices");
            choicesRef.onSnapshot(({docs}) => {
                const choices = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setChoices(choices);
            })
        } catch (error) {
            
        }

    }, [questionId, quizId])

    useEffect(() => {

        if (selected && currentAnswerAmount === 0) {
            setAnsweredAmount(answeredAmount+1)
            setCurrentAnswerAmount(1)
        }

    }, [selected])


    return (
        <div>
            {choices?.map((choice, index) => {
                return (
                    <SingleChoice 
                        key={index} 
                        choice={choice}
                        correctAmount={correctAmount}
                        setCorrectAmount={setCorrectAmount}
                        isSubmitted={isSubmitted}
                        mode={mode} 
                        quizId={quizId}
                        questionId={questionId}
                        selected={selected}
                        setSelected={setSelected}
                    />
                )
            })}
        </div>
    )

}
export default QuestionChoices